import { createContext, useContext } from 'react';
import { FilterPanelContextType } from '../types';

export const FilterPanelContext = createContext<FilterPanelContextType | null>(
  null
);
export const useFilterPanelContext = () => {
  const ctx = useContext(FilterPanelContext);
  if (!ctx)
    throw new Error(
      'FilterPanel.* component must be used within <FilterPanel>'
    );
  return ctx;
};
